import { boardsCollection } from "../firebase";

/**
 * Given a path in a doc like: columns.123.cards.234
 * And an object with fields to update for that specific card.
 * Prepare the payload to be sent to update (or create if they don't exist) this object.
 * e.g output: {
    "columns.12345.cards.3453.content": "This is the card content",
    "columns.12345.cards.3453.tags": ["sprint2"],
    "columns.12345.cards.3453.object": {\"test\":\"this is test\",\"id\":5}
}
 * @param {} documentUpdatePathString 
 */

export function prepareFirebaseUpdatePayload(
  documentUpdatePathString,
  fieldsToUpdate
) {
  return Object.keys(fieldsToUpdate).reduce(
    (firebaseUpdatePayload, fieldName) => {
      // handle array fields update
      if (
        fieldsToUpdate[fieldName] &&
        Array.isArray(fieldsToUpdate[fieldName])
      ) {
        return {
          ...firebaseUpdatePayload,
          [`${documentUpdatePathString}.${fieldName}`]: fieldsToUpdate[
            fieldName
          ],
        };
      }
      // handle object fields update
      if (
        typeof fieldsToUpdate[fieldName] === "object" &&
        !Array.isArray(fieldsToUpdate[fieldName]) &&
        fieldsToUpdate[fieldName] !== null
      ) {
        return {
          ...firebaseUpdatePayload,
          [`${documentUpdatePathString}.${fieldName}`]: fieldsToUpdate[
            fieldName
          ],
        };
      }
      return {
        ...firebaseUpdatePayload,
        [`${documentUpdatePathString}.${fieldName}`]: fieldsToUpdate[fieldName],
      };
    },
    {}
  );
}

/**
 * Checks if certain nested object exist in db or not
 */
export const doesObjectExistInDb = async (documentId, objectPathString) => {
  // step one, check if card exist in db before you send update request
  try {
    const board = await (await boardsCollection.doc(documentId).get()).data();
    if (!getProperty(objectPathString, board)) {
      return false;
    }
  } catch (err) {
    return false;
  }
  return true;
};

/**
 * A function given a dot notion string path and an object, it uses the string to retrive the
 * value if it exist in the object.
 * (used to generalize the functionality of "does object X exist in this db document path?")
 *
 * @param String nested A dot notation style parameter reference (ie "urls.small")
 * @param Object object (optional) The object to search
 *
 * @return the value of the property in question
 */

function getProperty(propertyName, object) {
  let parts = propertyName.split("."),
    length = parts.length,
    i,
    property = object || this;

  for (i = 0; i < length; i++) {
    property = property[parts[i]];
  }

  return property;
}
